/**
 * Thin wrapper around gtag() so components don't need to check for its
 * existence and we get one place to add new event names.
 *
 * Consent handling: our index.html seeds Consent Mode v2 with
 * analytics_storage='denied' until the user accepts the cookie banner.
 * gtag buffers `event` calls made before consent and sends them once the
 * consent is updated to 'granted' — so it's safe to call track() at any
 * time; nothing leaks before consent.
 */

/** Extract just the domain portion of an email for GA4 params (never PII). */
export const emailDomain = (email) => {
  if (typeof email !== 'string') return '';
  const at = email.lastIndexOf('@');
  return at === -1 ? '' : email.slice(at + 1).toLowerCase();
};

/** Fire a GA4 event with the given params. Silent no-op if gtag is missing. */
export const track = (eventName, params = {}) => {
  try {
    if (typeof window === 'undefined') return;
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', eventName, params);
  } catch (_) {
    /* noop */
  }
};

export const events = {
  PLAYBOOK_SUBMIT: 'playbook_submit',
  CONTACT_SUBMIT: 'contact_submit',
  PRIVACY_REQUEST_SUBMIT: 'privacy_request_submit',
  GRAB_15_CALL_CLICK: 'grab_15_call_click',
  REQUEST_SAMPLE_BRIEFING_CLICK: 'request_sample_briefing_click',
};
